<template>
  <vs-popup class="vs-con-loading__container user-edit-popup"
            id="popup"
            title="DOWNLOAD SALES ORDER OUTSTANDING REPORT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(downloadReportDocument)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="search" name="search" rules="" v-slot="{ errors }">
                <small class="label">Search Term</small>
                <vs-input v-model="search"  name="search" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="from" name="from" rules="" v-slot="{ errors }">
                <small class="label">Due Date From</small>
                <flat-pickr style="display: none"
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="due_date_from"
                            placeholder="Choose Date"
                />
                <flat-pickr
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="due_date_from"
                            placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="to" name="to" rules="" v-slot="{ errors }">
                <small class="label">Due Date To</small>
                <flat-pickr style="display: none"
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="due_date_to"
                            placeholder="Choose Date"
                />
                <flat-pickr
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="due_date_to"
                            placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Download</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>

  </vs-popup>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const ReportingRepository = RepositoryFactory.get('reporting')
import 'flatpickr/dist/plugins/monthSelect/style.css'
import vSelect from 'vue-select'
import Utils from "@/mixins/Utils";

export default {
  name: "CreateCustomerCrmSnapshotPopUp",
  data () {
    return {
      open: false,
      endPoint: '',
      date:'',
      due_date_from: '',
      due_date_to: '',
      search: ''
    }
  },
  mixins: [ Utils ],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  methods:{
    openPopup(end_point, due_date_from, due_date_to , search) {
      this.open = true
      this.due_date_from = due_date_from ? due_date_from: ''
      this.due_date_to = due_date_to ? due_date_to: ''
      this.search = search ? search: ''
      this.endPoint = end_point
    },
    async downloadReportDocument(){
      this.$vs.loading()
      try {
        const response = await ReportingRepository.downloadSalesReportDocument(
          this.endPoint,
          `filter[due-date-from]=${this.due_date_from}&filter[due-date-to]=${this.due_date_to}&filter[search]=${this.search}&is_paginate=0`
        )
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `Sales Order Outstanding Report.xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.open = false
      } catch (e) {

      }
      this.$vs.loading.close()
    }
  },
}
</script>

<style scoped>

</style>
